import { useEffect } from 'react';
import type { SurrenderRootResponse } from 'src/apis/surrender-service/types';
import { useAxios } from 'src/hooks/use-axios';
import { handleError } from 'src/utils/handle-error';
import { reportToSentry } from 'src/utils/report-to-sentry';

const surrenderRootCacheKey = 'surrender-service-root';

export function useSurrenderRoot() {
  const request = useAxios(
    (axios, baseConfig) =>
      axios.request<SurrenderRootResponse>({
        ...baseConfig,
        url: PRISMA_CONFIG.surrenderService,
      }),
    { neededOnPageLoad: true, cacheKey: surrenderRootCacheKey }
  );

  useEffect(() => {
    request.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return request;
}

export type SurrenderRootRequest = ReturnType<typeof useSurrenderRoot>;

export function useOptionalSurrenderRoot() {
  const request = useAxios(
    (axios, baseConfig) =>
      axios.request<SurrenderRootResponse>({
        ...baseConfig,
        url: PRISMA_CONFIG.surrenderService,
        timeout: 5000,
      }),
    {
      neededOnPageLoad: true,
      cacheKey: surrenderRootCacheKey,
      onError(error) {
        const [_, report] = handleError(error, () => {});
        if (report) reportToSentry(error);
        return error;
      },
    }
  );

  useEffect(() => {
    request.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return request;
}

export type OptionalSurrenderRootRequest = ReturnType<
  typeof useOptionalSurrenderRoot
>;
